import React, { useEffect, useState } from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import { 
  Grid, 
  Paper, 
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Box,
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import UserHttpService from '../../api/UserHttpService';
import withAuthAdmin from '../../middleware/useWithAuthAdmin';

function NewHome() {
  const [dashboardData, setDashboardData] = useState({
    totalUsers: 0,
    totalBalance: '0.00'
  });

  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const data = await UserHttpService.getDashboardData();
        setDashboardData({
          totalUsers: data.total_users,
          totalBalance: data.total_balance
        });
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    fetchDashboardData();
  }, []);

  const fetchUsers = async (pageNumber = 1, searchTerm = '') => {
    try {
      setLoading(true);
      const response = await UserHttpService.getUsers(pageNumber, 20, searchTerm);
      setUsers(response.data);
      setTotalPages(response.pagination.total_pages);
      setTotalItems(response.pagination.total);
      setRowsPerPage(response.pagination.per_page);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(page + 1, search);
  }, [page, search]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-8">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                display: 'flex',
                alignItems: 'center',
                bgcolor: '#f5f5f5'
              }}
            >
              <PeopleIcon sx={{ fontSize: 40, mr: 2, color: '#1976d2' }} />
              <div>
                <Typography variant="h6" color="textSecondary">
                  Total de Usuários
                </Typography>
                <Typography variant="h4">
                  {dashboardData.totalUsers}
                </Typography>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                display: 'flex',
                alignItems: 'center',
                bgcolor: '#f5f5f5'
              }}
            >
              <AccountBalanceWalletIcon sx={{ fontSize: 40, mr: 2, color: '#2e7d32' }} />
              <div>
                <Typography variant="h6" color="textSecondary">
                  Saldo Total
                </Typography>
                <Typography variant="h4">
                  R$ {dashboardData.totalBalance}
                </Typography>
              </div>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
              <Box sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  label="Buscar usuários"
                  variant="outlined"
                  value={search}
                  onChange={handleSearchChange}
                />
              </Box>
              
              <TableContainer sx={{ maxHeight: 'calc(100vh - 400px)' }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome Completo</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>CPF</TableCell>
                      <TableCell>Telefone</TableCell>
                      <TableCell>Plano</TableCell>
                      <TableCell align="right">Saldo</TableCell>
                      <TableCell>Plataforma</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.map((user, index) => (
                      <TableRow key={index}>
                        <TableCell>{user.fullName}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell>{user.cpf}</TableCell>
                        <TableCell>{user.phone || '-'}</TableCell>
                        <TableCell>{user.plan}</TableCell>
                        <TableCell align="right">R$ {user.balance}</TableCell>
                        <TableCell>{user?.user_platform}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={totalItems}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[rowsPerPage]}
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </MainLayout>
  );
}

export default withAuthAdmin(NewHome);
